import { useEffect, useState } from "react";

// Decides the page's video / no-video layout from the video report, but only
// ever changes the decision once that report has settled. While a refetch is
// in flight (or failed) the previous layout stays put, so changing campaigns
// or dates doesn't flash the other layout and remount the widgets that move
// between rows. Before the first report arrives the video layout is assumed.
const useHasVideoLayout = ({
  hasVideo,
  isSettled,
}: {
  hasVideo: boolean;
  isSettled: boolean;
}): boolean => {
  const [decided, setDecided] = useState(true);

  useEffect(() => {
    if (isSettled) setDecided(hasVideo);
  }, [hasVideo, isSettled]);

  return decided;
};

export default useHasVideoLayout;
